export default {
  navbar: {
    home: 'الرئيسية',
    jobs: 'الوظائف',
    companies: 'الشركات',
    about: 'من نحن',
    customerService: 'خدمة العملاء',
    signIn: 'تسجيل الدخول',
    register: 'التسجيل'
  },
  customerService: {
    title: 'اتصل بخدمة العملاء',
    subtitle: 'فريق الدعم المهني متواجد دائماً للرد على استفساراتك على مدار الساعة.',
    onlineService: 'الخدمة عبر الإنترنت',
    serviceDescription: 'فريق الدعم المهني متواجد دائماً للرد على استفساراتك على مدار الساعة.',
    startChat: 'ابدأ محادثة عبر الإنترنت',
    responseTime: 'متوسط وقت الرد: 30 ثانية',
    instantResponse: 'استجابة فورية',
    instantResponseDesc: 'فريق خدمة العملاء متواجد عبر الإنترنت على مدار الساعة، متوسط وقت الرد أقل من دقيقتين',
    professionalTeam: 'فريق احترافي',
    professionalTeamDesc: 'موظفو خدمة العملاء المدربون تدريباً صارماً ومتعرفون على جميع العمليات التجارية',
    securityPrivacy: 'الأمان والخصوصية',
    securityPrivacyDesc: 'جميع معلوماتك مشفرة لضمان الأمان المطلق',
    serviceOnline: 'الخدمة متصلة',
    seniorConsultant: 'مستشار عميل أول'
  },
  home: {
    heroTitle: 'ابحث عن وظيفتك المثالية في صناعة السينما',
    heroSubtitle: 'تواصل مع أفضل دور السينما وشركات الترفيه. ابدأ رحلتك في عالم السينما المثير اليوم.',
    popularCategories: 'فئات الوظائف الشائعة',
    categoriesDescription: 'استكشف الفرص في مختلف مجالات السينما والترفيه',
    featuredJobOpportunities: 'فرص العمل المميزة',
    discoverLatestOpenings: 'اكتشف أحدث الوظائف في أفضل دور السينما',
    openPositions: 'وظائف شاغرة',
    quickApply: 'تقديم سريع',
    whyChooseUs: 'لماذا تختارنا',
    joinLargestNetwork: 'انضم إلى أكبر شبكة من المحترفين في مجال السينما',
    categories: {
      theaterOperations: {
        title: 'إدارة السينما',
        description: 'إدارة العمليات اليومية للسينما وضمان سلاسل العرض'
      },
      boxOfficeManagement: {
        title: 'إدارة المكتب',
        description: 'إدارة مبيعات التذاكر وخدمة العملاء في المكتب'
      },
      cinemaTechnology: {
        title: 'تقنية السينما',
        description: 'صيانة وتشغيل أحدث معدات وأنظمة السينما'
      },
      customerService: {
        title: 'خدمة العملاء',
        description: 'تقديم خدمة متميزة لجمهور السينما'
      },
      foodBeverage: {
        title: 'المأكولات والمشروبات',
        description: 'إدارة متجر المأكولات وخدمات التقديم'
      },
      marketingPromotions: {
        title: 'التسويق والترويج',
        description: 'إنشاء وتنفيذ استراتيجيات تسويقية لدور السينما'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: 'مدير السينما',
        company: 'AMC Theatres',
        location: 'نيويورك، نيويورك',
        type: 'عمل كامل',
        salary: '$65K - $85K',
        benefit: 'الاستحقاق'
      },
      digitalProjectionist: {
        title: 'مخرج رقمي',
        company: 'Regal Cinemas',
        location: 'لوس أنجلوس، كاليفورنيا',
        type: 'عمل كامل',
        salary: '$45K - $60K',
        benefit: 'التدريب'
      },
      marketingCoordinator: {
        title: 'منسق التسويق',
        company: 'Cinemark',
        location: 'شيكاغو، إلينوي',
        type: 'عمل كامل',
        salary: '$50K - $65K',
        benefit: 'العمل عن بعد'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: 'شبكة صناعية كبيرة',
        description: 'تواصل مع أكثر من 2,500 من دور السينما وشركات الترفيه حول العالم',
        stat: 'أكثر من 15,000 مستخدم نشط'
      },
      verifiedEmployers: {
        title: 'أرباب عمل موثوقون',
        description: 'جميع أرباب العمل مراجعون بدقة لضمان توافر فرص حقيقية',
        stat: '100% شركات موثوقة'
      },
      careerGrowth: {
        title: 'تطور مهني',
        description: 'الوصول إلى موارد تدريبية وفرص الترقية',
        stat: '89% معدل نجاح'
      }
    }
  },
  jobs: {
    heroTitle: 'انضم إلى عائلتنا السينمائية',
    heroSubtitle: 'كن جزءاً من السحر الذي يحيي الحكايات. نبحث عن أشخاص متحمسين للانضمام إلى فريقنا المتنامي.',
    viewPositions: 'عرض الوظائف الشاغرة',
    currentOpenings: 'الوظائف الحالية',
    department: 'القسم',
    location: 'الموقع',
    applyNow: 'تقديم الآن',
    whyJoinUs: 'لماذا تنضم إلينا',
    ourCulture: 'ثقافتنا',
    applicationProcess: 'عملية التقديم',
    startYourJourney: 'ابدأ رحلتك',
    benefits: {
      freeMovieAccess: {
        title: 'أفلام مجانية',
        description: 'استمتع بمشاهدة أفلام مجانية غير محدودة لك ولعائلتك.'
      },
      careerGrowth: {
        title: 'التطور المهني',
        description: 'تدريب شامل ومسارات واضحة للترقي الوظيفي.'
      },
      flexibleSchedule: {
        title: 'جدول مرن',
        description: 'خيارات جدول عمل مرنة لتحقيق توازن بين الحياة والعمل.'
      }
    },
    jobList: [
      {
        title: 'مدير عمليات السينما',
        location: 'نيويورك، نيويورك',
        type: 'عمل كامل',
        description: 'القيادة للعمليات اليومية للسينما، مع ضمان تقديم خدمة عملاء متميزة في موقعنا الرئيسي.'
      },
      {
        title: 'مخرج رقمي رئيسي',
        location: 'لوس أنجلوس، كاليفورنيا',
        type: 'عمل كامل',
        description: 'تشغيل وصيانة أنظمة العرض الرقمية لضمان أفضل تجربة مشاهدة.'
      },
      {
        title: 'رئيس فريق متجر المأكولات',
        location: 'شيكاغو، إلينوي',
        type: 'عمل كامل',
        description: 'إدارة عمليات متجر المأكولات والقيادة لفريق خدمة تقديم احترافي.'
      },
      {
        title: 'مختص تجربة العملاء',
        location: 'ميامي، فلوريدا',
        type: 'عمل جزئي',
        description: 'تقديم خدمة متميزة وخلق تجارب لا تُنسى لضيوفنا.'
      },
      {
        title: 'مختص دعم فني',
        location: 'سياتل، واشنطن',
        type: 'عمل كامل',
        description: 'صيانة وإصلاح مشاكل معدات وأنظمة السينما.'
      },
      {
        title: 'منسق الفعاليات',
        location: 'بوسطن، ماساتشوستس',
        type: 'عمل كامل',
        description: 'تخطيط وتنفيذ عروض خاصة وفعاليات سينمائية خاصة.'
      }
    ],
    testimonials: [
      {
        name: 'إميلي ريتشاردسون',
        position: 'مدير السينما',
        quote: 'العمل هنا كان رحلة لا تُنسى. فرص النمو والبيئة الداعمة تجعل هذا أكثر من مجرد وظيفة.'
      },
      {
        name: 'مايكل أندرسون',
        position: 'مخرج رقمي رئيسي',
        quote: 'التقنية والمعدات التي نعمل بها من الدرجة الأولى. لأي محب للأفلام، هذا حلم يتحقق.'
      },
      {
        name: 'سارة مارتينيز',
        position: 'منسق الفعاليات',
        quote: 'العمل التعاوني هنا مذهل. نعمل معاً لخلق تجارب لا تُنسى لضيوفنا.'
      }
    ],
    applicationSteps: [
      {
        title: 'تقديم عبر الإنترنت',
        description: 'أرسل طلبك عبر بوابة التوظيف لدينا.'
      },
      {
        title: 'المراجعة الأولى',
        description: 'سيراجع فريقنا طلبك في غضون 48 ساعة.'
      },
      {
        title: 'المقابلة',
        description: 'قابل فريقنا لمناقشة الفرصة.'
      },
      {
        title: 'مرحباً بك',
        description: 'ابدأ رحلتك مع عائلتنا السينمائية.'
      }
    ]
  },
  companies: {
    searchPlaceholder: 'البحث عن شركات...',
    location: 'الموقع',
    companySize: 'حجم الشركة',
    industry: 'الصناعة',
    openPositions: 'وظائف شاغرة',
    viewJobs: 'عرض الوظائف',
    loadMore: 'تحميل المزيد من الشركات',
    companyList: [
      {
        name: 'Universal Entertainment Group',
        location: 'لوس أنجلوس، كاليفورنيا',
        size: 'أكثر من 5,000 موظف',
        description: 'شركة ترفيه عالمية رائدة تنتج وتوزع المحتوى السينمائي والتلفزيوني في جميع أنحاء العالم.'
      },
      {
        name: 'Cinemark Productions',
        location: 'نيويورك، نيويورك',
        size: '2,000-5,000 موظف',
        description: 'استوديو إنتاج حائز على الجوائز متخصص في الأفلام الكبرى والمحتوى الرقمي المبتكر.'
      },
      {
        name: 'Digital Cinema Solutions',
        location: 'سان فرانسيسكو، كاليفورنيا',
        size: '1,000-2,000 موظف',
        description: 'شركة تعتمد على التكنولوجيا تعمل على إحداث ثورة في تجربة السينما الرقمية من خلال حلول مبتكرة.'
      },
      {
        name: 'Paramount Digital Studios',
        location: 'شيكاغو، إلينوي',
        size: '500-1,000 موظف',
        description: 'خلق تجارب ترفيه رقمية من الجيل التالي من خلال التكنولوجيا المتطورة.'
      },
      {
        name: 'Global Theater Networks',
        location: 'ميامي، فلوريدا',
        size: '1,000-2,000 موظف',
        description: 'تشغيل سلاسل دور سينما فائقة الجودة بمرافق حديثة في المدن الكبرى.'
      },
      {
        name: 'Silverscreen Technologies',
        location: 'سياتل، واشنطن',
        size: '500-1,000 موظف',
        description: 'تطوير حلول برمجية متطورة لصناعة السينما الحديثة.'
      }
    ]
  },
  about: {
    heroTitle: 'من نحن',
    heroSubtitle: 'حيث يلتقي الخيال بالتكنولوجيا، تنبض الحياة في الحكايات من خلال عدسات مبتكرة.',
    ourStory: 'قصتنا',
    storyParagraph1: 'تأسست استوديو CineMaster في عام 2010، وكانت على الطليعة في مجال الابتكار السينمائي لأكثر من عقد. بدأت رحلتنا برؤية بسيطة ولكنها قوية: خلق حكايات بصرية مقنعة تجد صدى لدى الجمهور في جميع أنحاء العالم.',
    storyParagraph2: 'اليوم، نعتز بأننا نُعد من الاستوديوهات الإنتاجية الرائدة، حيث نتعاون مع علامات تجارية عالمية وفنانين موهوبين في الصناعة. التزامنا بالتميز وشغفنا برواية الحكايات يستمر في دفعنا إلى الأمام.',
    ourCoreValues: 'قيمنا الأساسية',
    creativeExcellence: 'التفوق الخلاق',
    creativeExcellenceDesc: 'دفع الحدود ووضع معايير جديدة في الرواية البصرية.',
    collaborativeSpirit: 'روح التعاون',
    collaborativeSpiritDesc: 'العمل معاً لتحويل الرؤية الفريدة إلى واقع.',
    qualityFirst: 'الجودة أولاً',
    qualityFirstDesc: 'السعي للتميز في كل صورة نخلقها.',
    meetOurTeam: 'تعرف على فريقنا',
    creativeDirector: 'مدير الخيال',
    leadCinematographer: 'مخرج الصور الرئيسي',
    technicalDirector: 'مدير الفني',
    productionManager: 'مدير الإنتاج',
    yearsExperience: 'سنوات خبرة',
    projectsCompleted: 'مشاريع مكتملة',
    industryAwards: 'جوائز الصناعة',
    happyClients: 'عملاء سعداء'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. جميع الحقوق محفوظة.',
    description: 'ربط المواهب بالفرص في صناعة السينما. ابحث عن دورك التالي في إدارة السينما أو الإدارة أو منصب تقني.',
    quickLinks: 'روابط سريعة',
    jobSeeker: 'الباحث عن وظيفة',
    newsletter: 'نشرة إخبارية',
    newsletterText: 'اشترك لاستلام آخر التحديثات حول الوظائف والنصائح المهنية.',
    emailPlaceholder: 'بريدك الإلكتروني',
    subscribe: 'اشترك',
    quickLinksList: ['من نحن', 'اتصل بنا', 'سياسة الخصوصية', 'شروط الخدمة'],
    jobSeekerLinksList: ['تصفح الوظائف', 'موارد مهنية', 'نصائح السيرة الذاتية', 'تنبيهات الوظائف']
  }
}